<template>
    <b-container>
        <h4 class="px-2 pb-3 text-center text-primary text-uppercase">{{ title }}</h4>
        <b-card class="my-md-4 bg-none" body-class="px-0">
            <b-card-text v-html="content"></b-card-text>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios';

export default {
    name: "Terms",
    data: () => ({
        loading: false,
        title: '',
        content: ''
    }),
    created () {
        this.getData();
    },
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'termspage');
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/terms').then((res) => {
                this.title = res.data.terms.title;
                this.content = res.data.terms.content;
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
            });
        }
    }
}
</script>

<style scoped>

</style>
